export default "__VITE_PUBLIC_ASSET__742d58fc__"